<template>
    <div class="printOrderDetails">
        <!-- 订单状态 -->
        <div class="detailsState">
            <div class="detailsState_one">
                <i
                    class="el-icon-arrow-left"
                    @click="$router.go(-1)"
                ></i>
                <p class="detailsState_one_title">订单状态</p>
                <span v-if="processActive==='UN_CONFIRM'">买家已下单，待商家确认</span>
                <span v-if="processActive==='UN_PAY'">已确认，待买家付款</span>
                <span v-if="processActive==='OFFLINE_UN_CONFIRM'">线下支付待确认</span>
                <span v-if="processActive==='DELIVERY_ON_CASH_UN_CONFIRM'">货到付款待确认</span>
                <span v-if="processActive==='UN_EFFECT'">买家已付款，待实施</span>
                <span v-if="processActive==='UN_APPRAISE'">买家确认已实施</span>
                <span v-if="processActive==='FINISHED'">交易已完成</span>
                <span v-if="processActive==='UN_CANCEL'">交易关闭</span>
            </div>
            <!--<div class="detailsState_one">
                <p>
                    商家还有
                    <span class="detailsState_one_time">{{day}}天{{hr}}小时{{min}}分{{sec}}秒</span>
                    来确认实施
                </p>
            </div>-->
        </div>
        <!-- 报价流程 -->
        <div class="details">
            <div class="detailsProcess">
                <div class="processItem" v-if="processActive!=='UN_CANCEL' && orderBase.payType == 'OFFLINE_PAY' && orderBase.payChannel == 'TRANSFER'" v-for="(item,index) in processList1" :key="index">
                    <div :class="processActive === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
                <div class="processItem" v-if="processActive!=='UN_CANCEL' && orderBase.payType == 'DELIVERY_ON_CASH' && orderBase.payChannel == 'DELIVERY_ON_CASH'" v-for="(item,index) in processList2" :key="index">
                    <div :class="processActive === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
                <div class="processItem" v-if="processActive!=='UN_CANCEL' && orderBase.payType !== 'OFFLINE_PAY' && orderBase.payChannel !== 'TRANSFER' && orderBase.payType !== 'DELIVERY_ON_CASH' && orderBase.payChannel !== 'DELIVERY_ON_CASH'" v-for="(item,index) in processList" :key="index">
                    <div :class="processActive === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== 'FINISHED'"></i>
                </div>
            </div>
            <!--订单信息-->
            <div class="orderInformation">
                <div class="orderTop">
                    <h3>订单信息</h3>
                    <div class="orderItem">
                        <div class="name">服务商：</div>
                        <!-- <div class="content">{{ serviceInfo.enterPriseName }} <i class="iconfont icon-weixin" @click="startChat(serviceInfo.enterPriseId)"></i></div> -->
                        <div class="content">{{ serviceInfo.enterPriseName }}</div>
                    </div>
                </div>
                <div class="orderBottom">
                    <div class="orderItem">
                        <div class="name">订单编号：</div>
                        <div class="content">{{ orderBase.orderNo }}</div>
                    </div>
                    <div class="orderItem">
                        <div class="name">创建时间：</div>
                        <div class="content">{{ orderBase.createDate }}</div>
                    </div>
                    <div class="orderItem" v-if="orderBase.payType!=null">
                        <div class="name">付款时间：</div>
                        <div class="content">{{ orderBase.payDate }}</div>
                    </div>
                    <div class="orderItem" v-if="orderBase.payType!=null">
                        <div class="name">付款渠道：</div>
                        <div class="content">{{ orderBase.payChannelCn }}</div>
                    </div>
                </div>
                <!--<div class="orderBottom" style="padding-top: 20px;">
                    <div class="orderItem" style="width: 100%;">
                        <div class="name">备注：</div>
                        <div class="content"></div>
                    </div>
                </div>-->
            </div>
            <!--发票信息-->
            <div class="basicInformation">
                <div class="invoiceInformation" v-if="invoiceInfo">
                    <h3>发票信息</h3>
                    <div class="goodsItem">
                        <div class="name">发票要求：</div>
                        <div class="content">{{ serviceInfo.invoiceType=='ZZFP'?'纸质发票':'电子发票' }}</div>
                    </div>
                    <div class="goodsItem">
                        <div class="name">发票类型：</div>
                        <div class="content">{{ invoiceInfo.invoiceType=='NORMAL'?'增值税普通发票':'增值税专用发票' }}</div>
                    </div>
                    <div class="goodsItem" v-if="invoiceInfo.invoiceType=='SPECIAL'">
                        <div class="name">开票信息：</div>
                        <div class="content">{{ invoiceInfo.title }}
                            <el-popover
                                placement="right"
                                width="400"
                                trigger="click">
                                <div class="billingInformation ">
                                    <div class="title">开票信息</div>
                                    <div class="billingContent">
                                        <div class="billingItem">
                                            <div class="name">开票抬头：</div>
                                            <div class="content">{{ invoiceInfo.title }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">纳税人识别号：</div>
                                            <div class="content">{{ invoiceInfo.code }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">地址：</div>
                                            <div class="content">{{ invoiceInfo.code }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">电话：</div>
                                            <div class="content">{{ invoiceInfo.mobile }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">开户行：</div>
                                            <div class="content">{{ invoiceInfo.bank }}</div>
                                        </div>
                                        <div class="billingItem">
                                            <div class="name">账号：</div>
                                            <div class="content">{{ invoiceInfo.bankAccount }}</div>
                                        </div>
                                    </div>
                                </div>
                                <el-button type="text"  slot="reference" style="padding: 0 0 0 10px;">详细</el-button>
                            </el-popover>
                        </div>
                    </div>
                    <!--邮寄地址和电子邮箱根据发票类型显示其中一个-->
                    <div class="goodsItem" v-if="serviceInfo.invoiceType=='ZZFP'">
                        <div class="name">发票邮寄地址：</div>
                        <div class="content">{{ payeeInfo.province }}{{ payeeInfo.city }}{{ payeeInfo.district }}{{ payeeInfo.areaInfo }}</div>
                    </div>
                    <div class="goodsItem" v-else>
                        <div class="name">电子邮箱：</div>
                        <div class="content">{{ invoiceInfo.payeeEmail }}</div>
                    </div>
                </div>
                <div v-else>
                    <h3>发票信息</h3>
                    <div class="goodsItem">
                        <div class="name">暂未开具发票</div>
                    </div>
                </div>
            </div>
            <!--服务信息-->
            <div class="printInformation">
                <h3>服务信息</h3>
                <div class="printTableContent">
                    <div class="tableHeader">
                        <div class="name">打印服务</div>
                        <div class="price">单价</div>
                        <div class="price">实付款</div>
                    </div>
                    <div class="tableBody">
                        <div class="name">
                            <div class="orderInfo">
                                <img :src="serviceInfo.serviceImg" alt="">
                                <div class="infoContent">
                                    <div class="infoName" :title="serviceInfo.serviceName">{{ serviceInfo.serviceName }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="price">
                            <div>
                                ¥ {{ serviceInfo.servicePrice }}
                            </div>
                        </div>
                        <div class="price">
                            <div>
                                ¥ {{ serviceInfo.totalPrice }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getAddressDetail, findInvoiceInfo, getServiceOrderDetail
} from '../../utils/interface';
export default {
    name: "printOrderDetails",
    data() {
        return {
            processActive: '',
            invoiceStatus: '',
            processList: [
                {
                    id: 'UN_CONFIRM',
                    name: '卖家确认'
                },
                {
                    id: 'UN_PAY',
                    name: '订单支付'
                },
                {
                    id: 'UN_EFFECT',
                    name: '卖家线下实施'
                },
                {
                    id: 'UN_APPRAISE',
                    name: '评价'
                },
                {
                    id: 'UN_CANCEL',
                    name: '订单已取消'
                },
                {
                    id: 'FINISHED',
                    name: '完成'
                },
            ],
            processList1: [
                {
                    id: 'UN_CONFIRM',
                    name: '卖家确认'
                },
                {
                    id: 'UN_PAY',
                    name: '订单支付'
                },
                {
                    id: "OFFLINE_UN_CONFIRM",
                    name: "线下支付待确认",
                },
                {
                    id: 'UN_EFFECT',
                    name: '卖家线下实施'
                },
                {
                    id: 'UN_APPRAISE',
                    name: '评价'
                },
                {
                    id: 'UN_CANCEL',
                    name: '订单已取消'
                },
                {
                    id: 'FINISHED',
                    name: '完成'
                },
            ],
            processList2: [
                {
                    id: 'UN_CONFIRM',
                    name: '卖家确认'
                },
                {
                    id: 'UN_PAY',
                    name: '订单支付'
                },
                {
                    id: "DELIVERY_ON_CASH_UN_CONFIRM",
                    name: "货到付款待确认",
                },
                {
                    id: 'UN_EFFECT',
                    name: '卖家线下实施'
                },
                {
                    id: 'UN_APPRAISE',
                    name: '评价'
                },
                {
                    id: 'UN_CANCEL',
                    name: '订单已取消'
                },
                {
                    id: 'FINISHED',
                    name: '完成'
                },
            ],
            day: 0,
            hr: 0,
            min: 0,
            sec: 0,
            uuid:"",
            orderBase:"",
            serviceInfo:"",
            payeeInfo:"",
            invoiceInfo:"",
            type: '',
        }
    },
    created(){
        this.uuid = this.$route.params.uuid;
        this.type = this.$route.params.type;
        this.getServiceDetail();
    },
    mounted() {
        this.countdown()
    },
    methods: {
        getServiceDetail() {
            let params = {
                uuid: this.uuid
            };
            getServiceOrderDetail(params).then((res) => {
                if (res) {
                    this.serviceInfo = res;
                    this.orderBase = res.orderBase;
                    this.processActive = res.serviceStatus;
                    this.invoiceStatus = res.invoiceStatus;
                    // 发票地址
                    if (res.payeeUuid != null) {
                        getAddressDetail({uuid: res.payeeUuid}).then((res) => {
                            this.payeeInfo = res;
                        });
                    }
                    // 收票地址信息
                    if (res.invoiceUuid != null) {
                        findInvoiceInfo({uuid: res.invoiceUuid}).then((res) => {
                            this.invoiceInfo = res;
                        });
                    }
                }
            });
        },
        // 倒计时
        countdown() {
            // 定义结束时间戳
            let end = new Date('2022-01-02 00:00:00')
            // 定义当前时间戳
            let now = new Date()
            // 做判断当倒计时结束时都为0
            if (now >= end) {
                this.day = 0
                this.hr = 0
                this.min = 0
                this.sec = 0
                return
            }
            // 用结束时间减去当前时间获得倒计时时间戳
            let msec = end - now
            let day = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
            let hr = parseInt(msec / 1000 / 60 / 60 % 24)//算出小时数
            let min = parseInt(msec / 1000 / 60 % 60)//算出分钟数
            let sec = parseInt(msec / 1000 % 60)//算出秒数
            //给数据赋值
            this.day = day
            this.hr = hr > 9 ? hr : '0' + hr
            this.min = min > 9 ? min : '0' + min
            this.sec = sec > 9 ? sec : '0' + sec
            setTimeout(() => {
                this.countdown()
            }, 1000)
        },
    }
}
</script>

<style scoped lang="less">
p {
    margin: 0;
}
i {
    font-style: normal;
}
.printOrderDetails {
    background: #f5f5f5;
    margin-left: 20px;
    // 订单状态
    .detailsState {
        background: #fff;
        font-size: 14px;
        padding: 26px 32px;
        margin-bottom: 8px;
        .detailsState_one {
            display: flex;
            align-items: center;
            position: relative;
            &:nth-of-type(1) {
                margin-bottom: 16px;
            }
            i {
                font-size: 18px;
                margin-right: 5px;
                cursor: pointer;
                position: absolute;
                left: -24px;
            }
            span{
                color: rgba(0,0,0,.5);
            }
            .detailsState_one_title {
                font-size: 16px;
                font-weight: 700;
                margin-right: 8px;
            }
            .detailsState_one_time {
                color: #1890ff;
            }
        }
    }
    // 报价流程
    .details {
        background: #fff;
        padding: 0 8px 150px;
        .detailsProcess {
            border-bottom: 1px solid #efefef;
            display: flex;
            align-items: center;
            .processItem{
                display: flex;
                align-items: center;
                // cursor: pointer;
                // &:hover{
                //     .process_type{
                //         i {
                //             background: #1890ff;
                //             color: #fff;
                //             border: 1px solid #1890ff;
                //         }
                //         p {
                //             color: #000;
                //         }
                //     }
                // }
            }
            .process_type {
                width: 232px;
                height: 64px;
                // line-height: 64px;
                display: flex;
                align-items: center;
                // border-bottom: 2px solid #1890ff;
                text-align: center;
                justify-content: center;
                i {
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    border-radius: 50%;
                    color: rgba(0, 0, 0, 0.15);
                    line-height: 27px;
                    font-size: 14px;
                    margin-right: 8px;
                }
                p {
                    font-size: 16px;
                    color: rgba(0, 0, 0, 0.3);
                }
            }
            .typeIcon {
                color: rgba(0, 0, 0, 0.3);
                font-size: 18px;
            }
            .process_type2 {
                border-bottom: 3px solid #1890ff;
                i {
                    background: #1890ff;
                    color: #fff;
                    border: 1px solid #1890ff;
                }
                p {
                    color: #000;
                }
            }
        }
        .basicInformation{
            display: flex;
            padding: 25px 32px;
            border-bottom: 1px solid #ddd;
            h3{
                margin: 0;
                font-size: 16px;
                font-weight: 700;
                color: rgba(0, 0, 0, 0.85);
                line-height: 24px;
                padding-bottom: 20px;
            }
            .goodsItem{
                display: flex;
                padding-bottom: 14px;
                font-size: 14px;
                .name{
                    color: rgba(0, 0, 0, 0.85);
                    min-width: 80px;
                }
                .content{
                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }
        .orderInformation{
            padding: 25px 32px;
            border-bottom: 1px solid #ddd;
            h3{
                margin: 0;
                font-size: 16px;
                font-weight: 700;
                color: rgba(0, 0, 0, 0.85);
                line-height: 24px;
                padding-bottom: 20px;
            }
            .orderTop{
                display: flex;
                .orderItem{
                    padding-left: 50px;
                    i{
                        color: #1890FF;
                        padding-left: 10px;
                        cursor: pointer;
                    }
                }
            }
            .orderBottom{
                display: flex;
            }
            .orderItem{
                font-size: 14px;
                display: flex;
                width: 20%;
                .name{
                    color: rgba(0, 0, 0, 0.85);
                }
                .content{
                    color: rgba(0, 0, 0, 0.65);
                }
            }
        }
        .printInformation{
            padding: 25px 32px;
            border-bottom: 2px dashed #000;
            h3{
                margin: 0;
                font-size: 16px;
                font-weight: 700;
                color: rgba(0, 0, 0, 0.85);
                line-height: 24px;
                padding-bottom: 20px;
            }
            .printTableContent{
                .tableHeader{
                    display: flex;
                    height: 54px;
                    background:rgba(0,0,0,.02);
                    line-height: 54px;
                    font-size: 14px;
                    color: #000000;
                    .name{
                        flex: 1;
                        padding: 0 30px;
                        min-width: 600px;
                    }
                }
                .tableBody{
                    display: flex;
                    align-items: center;
                    .name{
                        text-align: left;
                    }
                    .explain {
                        padding: 20px;
                    }
                    .price{
                        color: #E42424;
                    }
                    .argumentsName {
                        padding-bottom: 8px;
                        font-size: 14px;
                        span{
                            color: rgba(51, 51, 51, 0.85);
                        }
                    }
                }
                .orderInfo {
                    padding: 30px 20px;
                    display: flex;
                    align-items: center;
                    img {
                        display: block;
                        width: 100px;
                        height: 100px;
                        border-radius: 10px;
                        margin-right: 30px;
                    }

                    .infoContent {
                        .infoName {
                            font-size: 14px;
                            color: #000000;
                            padding-bottom: 10px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            max-width: 550px;
                        }

                        .infoOther {
                            font-size: 13px;
                            color: #999999;
                            padding-bottom: 8px;
                        }
                    }
                }
                .sort{
                    width: 60px;
                    text-align: center;
                    padding: 0 10px;
                }
                .name{
                    flex: 1;
                    padding: 0 10px;
                    min-width: 600px;
                }
                .explain{
                    text-align: center;
                    padding: 0 10px;
                    width: 400px;
                }
                .price{
                    text-align: center;
                    padding: 0 10px;
                    width: 150px;
                }
                .num{
                    text-align: center;
                    padding: 0 10px;
                    width: 150px;
                }
            }
        }
        .commodityPrices{
            padding: 20px 30px 0 0;
            .priceItem{
                display: flex;
                justify-content: flex-end;
                padding-bottom: 15px;
                font-size: 14px;
                color: #404040;
                .content{
                    min-width: 100px;
                    text-align: right;
                }
                &.fontWeight{
                    font-weight: 700;
                    .content{
                        color: #FF375F;
                    }
                }
            }
        }
        .functionButton{
            position: fixed;
            bottom: 20px;
            right: 30px;
        }
    }
}
.billingInformation{
    .title{
        color: rgba(0, 0, 0, 0.85);
        padding: 5px 0 10px 15px;
        border-bottom: 1px solid #ddd;
        font-weight: 700;
    }
    .billingContent{
        padding: 10px 10px 0;
        color: rgba(0, 0, 0, 0.65);
        .billingItem{
            display: flex;
            padding-bottom: 10px;
        }
    }
}
.electronicInvoice {
    h3 {
        padding-bottom: 15px;
        color: #000;
        font-size: 15px;
    }

    .invoiceList {
        .invoiceItem {
            border: 1px solid #ddd;
            padding: 10px 50px 10px 15px;
            border-radius: 10px;
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            position: relative;

            .invoiceCheckBox {
                padding-right: 15px;
            }

            .type {
                font-size: 12px;
                color: #666;
                padding-bottom: 5px;
            }

            .name {
                font-size: 15px;
                color: #000;
                padding-bottom: 5px;
            }

            .num {
                font-size: 12px;
                color: #333;
            }

            .edit {
                position: absolute;
                right: 15px;
                top: 50%;
                margin-top: -10px;
                padding: 0;
            }
        }
    }

    .emailList {
        padding: 0 15px 15px;

        /deep/ .el-radio {
            margin-bottom: 15px;
            display: block;
            margin-right: 0;
        }
    }
}
.addressList{
    padding: 24px 15px 0;
    display: flex;
    flex-wrap: wrap;
    .addressItem{
        padding: 14px 22px;
        margin-bottom: 24px;
        margin-right: 30px;
        position: relative;
        width: 270px;
        border-radius: 8px;
        border: 2px dashed #E3E3E3;
        font-size: 14px;
        .addressBorder{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
        &.active{
            border: 2px dashed #fff;
        }
        &:nth-of-type(4n){
            margin-right: 0;
        }
        .checkBox{
            position: absolute;
            right: 22px;
            top: 14px;
        }
        .name{
            color: #000;
        }
        .tel{
            color: rgba(51, 51, 51, 0.85);
            padding: 6px 0;
        }
        .address{
            color: rgba(51, 51, 51, 0.85);
            line-height: 22px;
        }
    }
    .addItem{
        text-align: center;
        cursor: pointer;
        color: #666;
        &:hover{
            border: 2px dashed #1890FF;
        }
        .icon{
            font-size: 30px;
        }
        .addName{
            font-size: 14px;
            padding-top: 5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/serverOrderDetails.vue